var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPageText)?_c('div',{staticClass:"text-center mt-16 text-h5 primary--text"},[_vm._v(" "+_vm._s(_vm.pageText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }